import { render } from "./VisitasModal.vue?vue&type=template&id=56b751f7"
import script from "./VisitasModal.vue?vue&type=script&lang=js"
export * from "./VisitasModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__